import { message, message as toast } from "antd";
import moment from "moment";

// Currency Symbol
export const curSym = "$";

// Authorizationw
export const pipSetAccessToken = (token) => {
  if (!token) return;
  localStorage.setItem("rc01-token", token);
};
export const pipGetAccessToken = () => {
  return localStorage.getItem("rc01-token");
};
export const clearAuth = () => {
  localStorage.removeItem("rc01-token");
  localStorage.removeItem("users_data_rc01");
  message.success("Successfully logged out");
};

// Profile
export const pipSaveProfile = (profile) => {
  if (!profile) return;
  else localStorage.setItem("users_data_rc01", JSON.stringify(profile));
};

export const pipGetProfile = () => {
  const profile = localStorage.getItem("users_data_rc01");
  return profile ? JSON.parse(profile) : {};
};

// Date View Format
export const pipViewDate = (date) => {
  if (!date) return;
  return moment(date).format("DD-MM-YYYY");
};

// Message Handlers
export const pipSuccessMessage = (message) => {
  if (!message) return;
  return toast.success(message);
};

export const pipErrorMessage = (message) => {
  if (!message) return;
  return toast.error(message);
};

// Profile
export const pipSaveTransictionId = (profile) => {
  if (!profile) return;
  else localStorage.setItem("rc01_transictionId", JSON.stringify(profile));
};

export const pipGetTransictionId = () => {
  const profile = localStorage.getItem("rc01_transictionId");
  return profile ? JSON.parse(profile) : {};
};

export const getSubstring = (str, len, appendStr = "...") => {
  if (!str) return "";
  if (str?.length <= len) return str;
  return str?.substring(0, len) + appendStr;
};

export const getOrderStatus = (status) => {
  switch (status) {
    case 0:
      return <span style={{ color: "orange" }}>Pending</span>;
    case 1:
      return <span style={{ color: "green" }}>Completed</span>;
    case 2:
      return <span style={{ color: "red" }}>Rejected</span>;
    case 3:
      return <span style={{ color: "red" }}>Cancelled</span>;
    case 4:
      return <span style={{ color: "red" }}>Failed</span>;
    default:
      return "";
  }
};

export function capitalizeFirstLetter(input) {
  if (!input || typeof input !== "string") return "";
  return input?.charAt(0)?.toUpperCase() + input?.slice(1)?.toLowerCase();
}

export const pipSaveLoginRole = (role) => {
  if (!role) return;
  localStorage.setItem("google_login_role", JSON.stringify(role));
};

export const pipGetLoginRole = () => {
  return JSON.parse(localStorage.getItem("google_login_role"));
};

// Team directory
export const pipSaveTeamDirectory = (data) => {
  if (!data) return;
  else localStorage.setItem("Team-Member-Detail", JSON.stringify(data));
};

export const pipGetTeamDirectory = () => {
  const data = localStorage.getItem("Team-Member-Detail");
  return data ? JSON.parse(data) : {};
};


export const pipOpenLinksInNewTab = (html) => {
  if (!html) return "";

  return html.replace(
    /<a /g,
    '<a target="_blank" rel="noopener noreferrer" '
  );
};